export default __webpack_public_path__ + "static/media/video_TVhost.8d55e3bd.mp4";